export enum DocumentPeriod {
  LastMonth = "Last month",
  LastThreeMonths = "Last 3 months",
  LastSixMonths = "Last 6 months",
  LastTwelveMonths = "Last 12 months",
  Custom = "Custom",
}
